<template>
    <tbody>
    <tr v-if="showGroupsRow(car.shipping_group_id)">
        <td colspan="10" style="background-color: white; font-size: medium">
            <i class="fas fa-ship"></i>
            {{ car.shipping_group.id }}
            <span @click="lockUnlockShippingGroup(null)" v-if="car.shipping_group.locked" class="icon has-text-danger">
                 <i class="fas fa-lock"></i>
            </span>
            <span @click="lockUnlockShippingGroup(1)" v-else class="icon has-text-success">
                 <i class="fas fa-lock-open"></i>
            </span>
            {{ car.shipping_group.name }}
            ({{ getShippingGroupType(car.shipping_group.type) }})
            ETD: <span class="has-text-primary">{{ car.estimated_departure }}</span>
            ETA: <span class="has-text-primary">{{ car.estimated_arrival }}</span>
            VESSEL: <span class="has-text-primary">{{ car.vessel }}</span>
            B/l#: <span class="has-text-primary">{{ car.bill_of_landing_number }}</span>
            <label class="checkbox">
                <input type="checkbox" v-model="isChecked">
            </label>
        </td>
    </tr>
    <tr :class="isStriped">
        <td :class="{ 'headcol headcol-1' : isAdmin, 'gray': isStriped === 'gray', 'white': isStriped === 'white' }">
            <div class="level">
                <figure class="image  is-32x32" @click="index = 0" style="float: left;">
                    <img :src="$appUrl+'/storage/photos/'+ car.id +'/2.jpg'" @error="imgUrlAlt($event, car.id, $appUrl)"/>
                </figure>
            </div>
        </td>
        <td :class="{ 'headcol headcol-2' : isAdmin, 'gray': isStriped === 'gray', 'white': isStriped === 'white' }">
            <router-link :to="'/car/' + car.id" class="button is-small" target="_blank">
                <span class="icon is-small" style="margin-right: 5px;"><i class="fas fa-search-plus"></i></span>
                {{ car.bid }}
            </router-link>
        </td>
        <td v-if="isAdmin" :class="{ 'headcol headcol-3' : isAdmin, 'gray': isStriped === 'gray', 'white': isStriped === 'white' }" style="min-width: 150px;">
            <chassis-column :car="car"></chassis-column>
        </td>
        <td v-else>{{ car.model_type_en }}</td>
        <td v-if="isAdmin || isSalesStaff" :class="{ 'main-col nowrap' : isAdmin, 'gray': isStriped === 'gray', 'white': isStriped === 'white'  }">
            <label class="checkbox">
                <input type="checkbox" :value="car.id" @click="selectCar(car)" v-model="checkedCars">
                Select
            </label>
        </td>
        <td v-if="isAdmin" nowrap>
            <multi-select v-model="carData.query.shipping_group_id"
                          :options="shippingGroups"
                          class="shipping-group-select"
                          :show-labels="false"
                          :tagable="false"
                          @select="updateGroup"
                          placeholder="Type...">
            </multi-select>
        </td>
        <td v-if="!isAdmin">
            <span v-if="car.shipping_group_id > 0">{{ car.shipping_group.name }}</span>
            <span v-else>No group!</span>
        </td>
        <td v-if="isAdmin">{{ car.manager.name }}</td>
        <td>
            <buy-column v-if="isAdmin" :car="car"></buy-column>
            <button class="button is-small date-select" :class="{'bold': isFilled(car.purchase_date) }"  v-else>{{  formatDate(car.purchase_date) }}</button>
        </td>
        <td>
            <span v-if="car.shipping_group_id > 0">#{{ car.shipping_group.id }}</span>
            <span v-else>No group!</span>
        </td>
        <td v-if="isAdmin" style="min-width: 150px;">
            <auction-name-column :car="car"></auction-name-column>
        </td>
        <td v-else>{{ car.auction_name}}</td>
        <td>{{ car.company }}</td>
        <td class="nowrap">{{ car.model_name_en }}</td>
        <td>{{ car.model_year_en }}</td>
        <td>{{ car.price * 1000 | formatNumber }}</td>
        <td>
            <proforma-invoice-column  v-if="isAdmin" :car="car"></proforma-invoice-column>
            <invoice-download-column v-else :car="car"></invoice-download-column>
        </td>
        <td v-if="isAdmin">{{ car.payment ? car.payment : 'UNPAID' }}</td>
        <td v-if="isAdmin">
            <payment-date-column :car="car"></payment-date-column>
        </td>
        <td v-if="isAdmin">
            <remarks-column :car="car"></remarks-column>
        </td>
        <td>
            <balance-column :car="car"></balance-column>
        </td>
        <td v-if="isAdmin">
            <inland-company-column :car="car"></inland-company-column>
        </td>
        <td>
            <yard-arrival-date-column v-if="isAdmin" :car="car"></yard-arrival-date-column>
            <button class="button is-small date-select" :class="{'bold': isFilled(car.yard_arrival_date) }" v-else>{{  formatDate(car.yard_arrival_date) }}</button>
        </td>
        <td v-if="isAdmin">
            <yard-column v-if="isAdmin" :car="car"></yard-column>
        </td>
        <td>
            <yard-pics-column v-if="isAdmin" :car="car"></yard-pics-column>
            <button class="button is-small date-select" :class="{'bold': isFilled(car.yard_pics) }" v-else>{{  formatDate(car.yard_pics)}}</button>
        </td>
        <td>
            <port-of-loading-column v-if="isAdmin" :car="car"></port-of-loading-column>
            <button class="button is-small tooltip" :class="{'bold': isFilled(car.port_of_loading) }" :data-tooltip="car.port_of_loading ? car.port_of_loading :'---'" v-else><span class="text-eclipse">{{ car.port_of_loading ? car.port_of_loading :'---' }}</span></button>
        </td>
        <td>
            <port-of-arrival-column v-if="isAdmin" :car="car"></port-of-arrival-column>
            <button class="button is-small tooltip" :class="{'bold': isFilled(car.port_of_arrival) }" :data-tooltip="car.port_of_arrival ?  car.port_of_arrival : '---'" v-else><span class="text-eclipse">{{ car.port_of_arrival ?  car.port_of_arrival : '---' }}</span></button>
        </td>
        <td>
            <shipping-line-column v-if="isAdmin" :car="car"></shipping-line-column>
            <button class="button is-small tooltip" :class="{'bold': isFilled(car.shipping_line) }" :data-tooltip="car.shipping_line ? car.shipping_line : '---'" v-else><span class="text-eclipse">{{ car.shipping_line ? car.shipping_line : '---' }}</span></button>
        </td>
        <td>
            <vessel-column v-if="isAdmin" :car="car"></vessel-column>
            <button class="button is-small date-select tooltip" :class="{'bold': isFilled(car.vessel) }" :data-tooltip="car.vessel ? car.vessel : '---'" v-else><span class="text-eclipse">{{ car.vessel ? car.vessel : '---' }}</span></button>
        </td>
        <td class="nowrap">{{ daysPast(car.created_at) }} Day(s)</td>
        <td>
            <docs-recived-column v-if="isAdmin" :car="car"></docs-recived-column>
            <button class="button is-small date-select" :class="{'bold': isFilled(car.docs_received) }" v-else>{{  formatDate(car.docs_received) }}</button>
        </td>
        <td>
            <export-certificate-column v-if="isAdmin" :car="car"></export-certificate-column>
            <button class="button is-small date-select" :class="{'bold': isFilled(car.export_certificate) }" v-else>{{  formatDate(car.export_certificate) }}</button>
        </td>
        <td v-if="isAdmin">
            <export-declaration-column :car="car"></export-declaration-column>
        </td>
        <td v-if="isAdmin">
            <inspection-column :car="car"></inspection-column>
        </td>
        <td v-if="isAdmin">
            <inspection-date-column :car="car"></inspection-date-column>
        </td>
        <td>
            <estimated-departure-column v-if="isAdmin" :car="car"></estimated-departure-column>
            <button class="button is-small date-select" :class="{'bold': isFilled(car.estimated_departure) }" v-else>{{  formatDate(car.estimated_departure) }}</button>
        </td>
        <td>
            <estimated-arrival-column v-if="isAdmin" :car="car"></estimated-arrival-column>
            <button class="button is-small date-select" :class="{'bold': isFilled(car.estimated_arrival) }" v-else>{{  formatDate(car.estimated_arrival) }}</button>
        </td>
        <td>
            <bill-of-landing-column v-if="isAdmin" :car="car"></bill-of-landing-column>
            <button class="button is-small date-select" :class="{'bold': isFilled(car.bill_of_landing) }" v-else>{{ formatDate(car.bill_of_landing) }}</button>
        </td>
        <td>
            <docs-send-column v-if="isAdmin" :car="car"></docs-send-column>
            <button class="button is-small date-select" :class="{'bold': isFilled(car.docs_send) }" v-else>{{  formatDate(car.docs_send) }}</button>
        </td>
        <td v-if="isAdmin">
            <insurance-column :car="car"></insurance-column>
        </td>
        <vue-gallery-slideshow :images="images" :index="index" @close="index = null" :id="car.lot_id"></vue-gallery-slideshow>
    </tr>
    </tbody>
</template>

<script>
    import VueGallerySlideshow from 'vue-gallery-slideshow'
    import InlandCompanyColumn from '../../../../Cars/Columns/InlandCompanyColumn'
    import YardArrivalDateColumn from '../../../../Cars/Columns/YardArrivalDateColumn'
    import YardPicsColumn from '../../../../Cars/Columns/YardPicsColumn'
    import YardColumn from '../../../../Cars/Columns/YardColumn'
    import BuyColumn from '../../../../Cars/Columns/BuyColumn'
    import PortOfLoadingColumn from '../../../../Cars/Columns/PortOfLoadingColumn'
    import PortOfArrivalColumn from '../../../../Cars/Columns/PortOfArrivalColumn'
    import ShippingLineColumn from '../../../../Cars/Columns/ShippingLineColumn'
    import VesselColumn from '../../../../Cars/Columns/VesselColumn'
    import DocsRecivedColumn from '../../../../Cars/Columns/DocsRecivedColumn'
    import ExportCertificateColumn from '../../../../Cars/Columns/ExportCertificateColumn'
    import EstimatedDepartureColumn from '../../../../Cars/Columns/EstimatedDepartureColumn'
    import EstimatedArrivalColumn from '../../../../Cars/Columns/EstimatedArrivalColumn'
    import BillOfLandingColumn from '../../../../Cars/Columns/BillOfLandingColumn'
    import DocsSendColumn from '../../../../Cars/Columns/DocsSendColumn'
    import PaymentDateColumn from '../../../../Cars/Columns/PaymentDateColumn'
    import InspectionColumn from '../../../../Cars/Columns/InspectionColumn'
    import InspectionDateColumn from '../../../../Cars/Columns/InspectionDateColumn'
    import ExportDeclarationColumn from '../../../../Cars/Columns/ExportDeclarationColumn'
    import InsuranceColumn from '../../../../Cars/Columns/InsuranceColumn'
    import ChassisColumn from '../../../../Cars/Columns/ChassisColumn'
    import RemarksColumn from '../../../../Cars/Columns/RemarksColumn'
    import AuctionNameColumn from '../../../../Cars/Columns/AuctionNameColumn'
    import ProformaInvoiceColumn from '../../../../Cars/Columns/ProformaInvoiceColumn'
    import BalanceColumn from '../../../../Cars/Columns/BalanceColumn'
    import moment from 'moment'
    import apiCars from '../../../../../api/apiCars'
    import MultiSelect from 'vue-multiselect'
    export default {
        props:['car', 'i'],
        components: {
            VueGallerySlideshow,
            YardArrivalDateColumn,
            YardPicsColumn,
            BuyColumn,
            PortOfLoadingColumn,
            PortOfArrivalColumn,
            ShippingLineColumn,
            VesselColumn,
            DocsRecivedColumn,
            ExportCertificateColumn,
            EstimatedDepartureColumn,
            EstimatedArrivalColumn,
            BillOfLandingColumn,
            DocsSendColumn,
            InlandCompanyColumn,
            YardColumn,
            PaymentDateColumn,
            InspectionColumn,
            InspectionDateColumn,
            ExportDeclarationColumn,
            InsuranceColumn,
            ChassisColumn,
            RemarksColumn,
            AuctionNameColumn,
            ProformaInvoiceColumn,
            BalanceColumn,
            MultiSelect
        },
        data () {
            return {
                index: null,
                images: [],
                rowClass: '',
                carData: {
                    id: this.car.id,
                    query: {
                        shipping_group_id: null
                    }
                },
                statusLabels: [
                    {
                        tagClass: 'tag is-danger',
                        label: 'Canceled'
                    },
                    {
                        tagClass: 'tag is-link',
                        label: 'Active'
                    },
                    {
                        tagClass: 'tag is-success',
                        label: 'Win'
                    },
                    {
                        tagClass: 'tag is-warning',
                        label: 'Lose'
                    },
                    {
                        tagClass: 'tag is-warning',
                        label: 'Lose to other'
                    },
                    {
                        tagClass: 'tag is-warning',
                        label: 'Unsold'
                    },
                    {
                        tagClass: 'tag is-info',
                        label: 'Negotiations'
                    },
                ]
            }
        },
        methods: {
            lockUnlockShippingGroup(value) {
                if (!this.isAdmin) {
                    return
                }
                let data = {
                    id: this.car.shipping_group.id,
                    locked: value
                }
                this.$store.dispatch('updateShippingGroupById', data)
                this.$store.dispatch('fetchShippingGroups', this.car.user_id)
            },
            daysPast(date, eta){

                const one_day = 1000 * 60 * 60 * 24;

                const date1 = new Date();
                const date2 = new Date(date);

                const date1_ms = date1.getTime();
                const date2_ms = date2.getTime();

                // Calculate the difference in milliseconds
                const difference_ms = date1_ms - date2_ms;

                // Convert back to days and return
                return Math.round(difference_ms / one_day);
            },
            formatDate(date) {

                if(date){
                    return moment(date).format('M/D')
                }else{
                    return '---'
                }
            },
            selectCar(value){
                if (this.$store.getters.getShippingGroupCarsById(value.id).length > 0) {
                    this.$store.dispatch('removeCarFromShippingGroup', value.id)
                    this.$store.dispatch('removeFullCarFromShippingGroup', value)
                } else {
                    this.$store.dispatch('updateShippingGroupCars', value.id)
                    this.$store.dispatch('updateShippingGroupFullCars', value)
                }
            },
            getShippingGroupType(type) {
                return type < 2 ? 'RoRo' : 'Container'
            },
            goToUserPage(id){
                this.$router.push({ name: 'EditUser', params: { id: id } });
            },
            showGroupsRow(group){
                if (this.$store.getters.getCarsOrderColumn === 'shipping_group_id'){
                    if (group !== null) {
                        if (this.i === 0){
                            return true
                        }
                        return this.$store.getters.getCars[this.i - 1].shipping_group_id !== group
                    }
                }
            },
            updateGroup(){
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {

                    })
                    .catch(error => console.log(error))
            },
            imgUrlAlt(event, car_id, appurl){
                if(event.target.src.indexOf('1.jpg') > -1) {
                    event.target.src = '/static/images/hero-4.jpeg'
                }else{
                    event.target.src = appurl+'/storage/photos/'+ car_id +'/1.jpg';
                }
            },
            isFilled(value) {
                if (value !== null){
                    return  true;
                }
            },
        },
        computed: {
            checkedCars: {
                get: function () {
                    return  this.$store.getters.getShippingGroupCars
                },
                set: function (value) {

                }
            },
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            isSalesStaff() {
                if (this.$store.getters.getUserRole === 'Sales Staff') {
                    return true
                }
            },
            isStriped() {
                if (this.i % 2 === 0) {
                    return 'white'
                } else {
                    return 'gray'
                }
            },
            isNotMobile() {
                return  this.windowWidth > 450;
            },
            shippingGroups() {
                let groups = []

                this.$store.getters.getShippingGroups.forEach(function(element) {
                    groups.push(element.id);
                });

                return groups
            },
            isChecked: {
                set(value){
                    if(value){
                        if(this.$store.getters.getGroupIds.indexOf(this.car.shipping_group_id) < 0){
                            this.$store.dispatch('setShippingGroupIds', this.car.shipping_group_id)
                        }
                    }else{
                        this.$store.dispatch('removeShippingGroupId', this.car.shipping_group_id)
                    }
                }
            }
        },
        created() {
            for (let i = 1; i <= this.car.photos; i++) {
                this.images.push('https://unetworld.com/storage/photos/'+ this.car.id +'/'+ i +'.jpg')
            }
            this.carData.query.shipping_group_id = this.car.shipping_group_id
            this.carData.id = this.car.id
            this.$store.dispatch('removeAllShippingGroupIds');
        }
    }
</script>

<style scoped>
    /*tbody{*/
        /*overflow-x: scroll;*/
        /*max-height: 500px;*/
    /*}*/
    /*td {*/
        /*font-size: 10px;*/
        /*font-weight: bold;*/
        /*background-color: whitesmoke;*/
    /*}*/
    /*.is-responsive-table td {*/
        /*font-size: 10px;*/
    /*}*/
    /*.image {*/
        /*max-height: 32px;*/
        /*height: 32px;*/
        /*padding-left: 2px;*/
    /*}*/
    /*.is-automatic {*/
        /*background-color: rgba(0, 255, 255, 0.25);*/
    /*}*/
    /*.is-real {*/
        /*background-color: rgba(255, 255, 0, 0.27);*/
    /*}*/
    /*.is-win {*/

    /*}*/
    /*.is-canceled {*/

    /*}*/
    /*.nowrap {*/
        /*overflow: hidden;*/
        /*text-overflow: ellipsis;*/
        /*white-space: nowrap;*/
    /*}*/
    /*.is-responsive-table table {*/
        /*width: 100%;*/
    /*}*/
    /*.is-responsive-table th {*/
        /*font-size: small;*/
    /*}*/
    /*.long {*/
        /*min-width: 75px;*/
    /*}*/
    /*.link {*/
        /*border-bottom: 1px solid blue;*/
        /*cursor: pointer;*/
    /*}*/
    /*.headcol {*/
        /*position: absolute;*/
        /*z-index: 1;*/
        /*background-color: whitesmoke;*/
        /*border-style: solid;*/
        /*border-width: 1px;*/
        /*height: 42px;*/
    /*}*/
    /*.headcol-1 {*/
        /*width: 100px;*/
    /*}*/
    /*.headcol-2 {*/
        /*margin-left: 100px;*/
        /*width: 80px;*/
    /*}*/
    /*.headcol-3 {*/
        /*margin-left: 180px;*/
        /*width: 75px;*/
    /*}*/
    /*.headcol-4 {*/
        /*margin-left: 300px;*/
    /*}*/
    /*.main-col {*/
        /*padding-left: 265px!important;*/
    /*}*/

    .white {
        background-color: white;
    }
    .gray {
        background-color: whitesmoke;
    }
    tbody{
        overflow-x: scroll;
        max-height: 500px;
    }
    td {
        font-size: 10px;
        font-weight: bold;
        /*background-color: whitesmoke;*/
    }
    .is-responsive-table td {
        font-size: 10px;
    }
    .image {
        max-height: 32px;
        height: 32px;
        padding-left: 2px;
    }
    .is-automatic {
        background-color: rgba(0, 255, 255, 0.25);
    }
    .is-real {
        background-color: rgba(255, 255, 0, 0.27);
    }
    .is-win {

    }
    .is-canceled {

    }
    .nowrap {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .is-responsive-table table {
        width: 100%;
    }
    .is-responsive-table th {
        font-size: small;
    }
    .long {
        min-width: 75px;
    }
    .link {
        border-bottom: 1px solid blue;
        cursor: pointer;
    }
    .headcol {
        position: absolute;
        z-index: 1;
        border-style: solid;
        border-width: 1px;
        height: 42px;
    }
    .headcol-1 {
        width: 60px;
    }
    .headcol-2 {
        margin-left: 60px;
        width: 100px;
    }
    .headcol-3 {
        margin-left: 150px;
        width: 75px;
    }
    .headcol-4 {
        margin-left: 300px;
    }
    .main-col {
        padding-left: 320px!important;
    }
    .shipping {
        width: 100%;
        height: 40px;
        border-style: solid;
        border-width: 1px;
        border-color: whitesmoke;
    }
    .text-eclipse {
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .fixed {
        position: absolute;
    }
    .shipping-group-select {
        min-width: 100px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Users/User/Tabs/Garage/UserGarageTableRow.vue